/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { db } from './firebase';
import { collection, query, where, getDocs, doc, setDoc, getDoc, serverTimestamp, onSnapshot, limit } from 'firebase/firestore';

// ── Definición de insignias escalables por niveles ────────────────────────────

export const NIVELES = {
  bronce:  { label: 'Bronce',  orden: 1, gradient: 'linear-gradient(135deg, #8B4513 0%, #CD7F32 40%, #FFB347 70%, #CD7F32 100%)', glow: '#CD7F32', text: '#3d1a00', shine: 'rgba(255,200,100,0.4)' },
  plata:   { label: 'Plata',   orden: 2, gradient: 'linear-gradient(135deg, #6a6a6a 0%, #b0b0b0 35%, #e8e8e8 55%, #c0c0c0 75%, #888 100%)', glow: '#c0c0c0', text: '#1a1a1a', shine: 'rgba(255,255,255,0.5)' },
  oro:     { label: 'Oro',     orden: 3, gradient: 'linear-gradient(135deg, #7d5a00 0%, #D4A017 30%, #FFD700 55%, #FFA500 75%, #7d5a00 100%)', glow: '#FFD700', text: '#3d2a00', shine: 'rgba(255,240,100,0.6)' },
  platino: { label: 'Platino', orden: 4, gradient: 'linear-gradient(135deg, #1a0533 0%, #6a3fa0 25%, #a78bfa 50%, #38bdf8 70%, #1a0533 100%)', glow: '#a78bfa', text: '#0d0020', shine: 'rgba(167,139,250,0.5)' },
};

export const INSIGNIAS_DEF = [
  // ── Lectura ────────────────────────────────────────────────────────────────
  {
    id: 'lector',
    categoria: 'Lectura',
    nombre: { bronce: 'Primer capítulo', plata: 'Lector ávido', oro: 'Gran lector', platino: 'Bibliómano' },
    descripcion: { bronce: 'Marca 1 libro como leído', plata: 'Completa 5 libros', oro: 'Completa 25 libros', platino: 'Completa 100 libros' },
    umbrales: { bronce: 1, plata: 5, oro: 25, platino: 100 },
    campo: 'libros_leidos',
    icono: (color) => (
      <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: '100%' }}>
        <rect x="8" y="6" width="18" height="28" rx="2" fill={color} opacity="0.9"/>
        <rect x="12" y="6" width="18" height="28" rx="2" fill={color}/>
        <line x1="16" y1="13" x2="26" y2="13" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
        <line x1="16" y1="17" x2="26" y2="17" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
        <line x1="16" y1="21" x2="22" y2="21" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    id: 'coleccionista',
    categoria: 'Lectura',
    nombre: { bronce: 'Lista de deseos', plata: 'Explorador', oro: 'Coleccionista', platino: 'Archivista' },
    descripcion: { bronce: '5 libros en "Quiero leer"', plata: '20 libros guardados', oro: '50 libros guardados', platino: '100 libros guardados' },
    umbrales: { bronce: 5, plata: 20, oro: 50, platino: 100 },
    campo: 'libros_guardados',
    icono: (color) => (
      <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: '100%' }}>
        <path d="M20 6L22.5 13.5H30.5L24.2 18.2L26.7 25.7L20 21L13.3 25.7L15.8 18.2L9.5 13.5H17.5Z" fill={color}/>
        <circle cx="20" cy="32" r="3" fill={color} opacity="0.7"/>
      </svg>
    ),
  },
  // ── Social ──────────────────────────────────────────────────────────────────
  {
    id: 'social',
    categoria: 'Social',
    nombre: { bronce: 'Conocido', plata: 'Popular', oro: 'Referente', platino: 'Leyenda' },
    descripcion: { bronce: 'Consigue 1 seguidor', plata: '10 seguidores', oro: '50 seguidores', platino: '200 seguidores' },
    umbrales: { bronce: 1, plata: 10, oro: 50, platino: 200 },
    campo: 'seguidores',
    icono: (color) => (
      <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: '100%' }}>
        <circle cx="20" cy="14" r="6" fill={color}/>
        <path d="M8 32c0-6.627 5.373-10 12-10s12 3.373 12 10" stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
        <circle cx="30" cy="12" r="4" fill={color} opacity="0.7"/>
        <path d="M34 26c0-4-2.5-6.5-6-7" stroke={color} strokeWidth="2" strokeLinecap="round" opacity="0.7"/>
      </svg>
    ),
  },
  {
    id: 'mensajes',
    categoria: 'Chat',
    nombre: { bronce: 'Primer debate', plata: 'Conversador', oro: 'Orador', platino: 'Voz del club' },
    descripcion: { bronce: 'Envía 1 mensaje', plata: '50 mensajes', oro: '500 mensajes', platino: '2000 mensajes' },
    umbrales: { bronce: 1, plata: 50, oro: 500, platino: 2000 },
    campo: 'mensajes_enviados',
    icono: (color) => (
      <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: '100%' }}>
        <path d="M6 8h28a2 2 0 012 2v16a2 2 0 01-2 2H14l-6 6V10a2 2 0 012-2z" fill={color}/>
        <circle cx="14" cy="18" r="2" fill="white"/>
        <circle cx="20" cy="18" r="2" fill="white"/>
        <circle cx="26" cy="18" r="2" fill="white"/>
      </svg>
    ),
  },
  {
    id: 'valorador',
    categoria: 'Valoraciones',
    nombre: { bronce: 'Crítico', plata: 'Reseñador', oro: 'Árbitro del gusto', platino: 'Oráculo literario' },
    descripcion: { bronce: 'Valora 1 libro', plata: '10 valoraciones', oro: '50 valoraciones', platino: '200 valoraciones' },
    umbrales: { bronce: 1, plata: 10, oro: 50, platino: 200 },
    campo: 'valoraciones',
    icono: (color) => (
      <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: '100%' }}>
        <path d="M20 7l3.5 7.2 7.9 1.1-5.7 5.6 1.3 7.9L20 25l-7 3.8 1.3-7.9-5.7-5.6 7.9-1.1z" fill={color}/>
      </svg>
    ),
  },
  {
    id: 'eventos',
    categoria: 'Eventos',
    nombre: { bronce: 'Asistente', plata: 'Habitual', oro: 'Organizador', platino: 'Maestro del club' },
    descripcion: { bronce: 'Participa en 1 evento', plata: '5 eventos', oro: '20 eventos', platino: '50 eventos' },
    umbrales: { bronce: 1, plata: 5, oro: 20, platino: 50 },
    campo: 'eventos_participados',
    icono: (color) => (
      <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: '100%' }}>
        <rect x="6" y="10" width="28" height="24" rx="3" fill={color} opacity="0.9"/>
        <rect x="6" y="10" width="28" height="8" rx="3" fill={color}/>
        <rect x="14" y="6" width="3" height="8" rx="1.5" fill={color}/>
        <rect x="23" y="6" width="3" height="8" rx="1.5" fill={color}/>
        <path d="M13 24l4 4 10-8" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  // ── Especiales ──────────────────────────────────────────────────────────────
  {
    id: 'pionero',
    categoria: 'Especial',
    nombre: { bronce: 'Pionero' },
    descripcion: { bronce: 'Uno de los primeros 100 usuarios' },
    umbrales: { bronce: 1 },
    campo: 'es_pionero',
    unico: true,
    icono: (color) => (
      <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: '100%' }}>
        <path d="M20 4l4 8 8.5 1.5-6 6 1.5 8.5L20 24l-8 4 1.5-8.5-6-6L16 12z" fill={color}/>
        <circle cx="20" cy="20" r="5" fill="white" opacity="0.3"/>
        <path d="M17 20l2 2 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
];

// ── Calcular nivel actual de una insignia ─────────────────────────────────────
export function calcularNivel(insigniaDef, valor) {
  const umbrales = insigniaDef.umbrales;
  let nivelActual = null;
  let siguienteNivel = null;
  let siguienteUmbral = null;

  if (valor >= (umbrales.platino || Infinity)) { nivelActual = 'platino'; }
  else if (valor >= (umbrales.oro || Infinity)) { nivelActual = 'oro'; siguienteNivel = 'platino'; siguienteUmbral = umbrales.platino; }
  else if (valor >= (umbrales.plata || Infinity)) { nivelActual = 'plata'; siguienteNivel = 'oro'; siguienteUmbral = umbrales.oro; }
  else if (valor >= (umbrales.bronce || Infinity)) { nivelActual = 'bronce'; siguienteNivel = insigniaDef.unico ? null : 'plata'; siguienteUmbral = umbrales.plata; }

  return { nivelActual, siguienteNivel, siguienteUmbral };
}

// ── Componente visual de una insignia ─────────────────────────────────────────
export function InsigniaCard({ insigniaDef, valor = 0, pequeña = false }) {
  const { nivelActual, siguienteNivel, siguienteUmbral } = calcularNivel(insigniaDef, valor);
  const nivel = nivelActual ? NIVELES[nivelActual] : null;
  const bloqueada = !nivelActual;

  // Calcular progreso hacia el siguiente nivel
  let progreso = 0;
  let umbralAnterior = 0;
  if (!bloqueada && siguienteUmbral) {
    const nivelAnteriorKey = nivelActual === 'bronce' ? null : nivelActual === 'plata' ? 'bronce' : nivelActual === 'oro' ? 'plata' : 'oro';
    umbralAnterior = nivelAnteriorKey ? insigniaDef.umbrales[nivelAnteriorKey] : 0;
    progreso = Math.min(((valor - umbralAnterior) / (siguienteUmbral - umbralAnterior)) * 100, 100);
  }

  // Progreso hacia el bronce si aún no se tiene
  if (bloqueada) {
    progreso = Math.min((valor / insigniaDef.umbrales.bronce) * 100, 100);
  }

  const size = pequeña ? 64 : 100;
  const iconColor = nivel ? 'white' : '#555';

  if (pequeña) {
    return (
      <div title={`${insigniaDef.categoria} — ${nivelActual ? `${nivel.label}: ${insigniaDef.nombre[nivelActual]}` : 'Bloqueada'}`}
        style={{ width: size, height: size, borderRadius: '50%', position: 'relative', cursor: 'default', flexShrink: 0 }}>
        {/* Fondo */}
        <div style={{
          width: '100%', height: '100%', borderRadius: '50%',
          background: nivel ? nivel.gradient : '#1a1a1a',
          boxShadow: nivel ? `0 0 12px ${nivel.glow}66, inset 0 1px 0 ${nivel.shine}` : 'none',
          border: nivel ? `2px solid ${nivel.glow}88` : '2px solid #2a2a2a',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          filter: bloqueada ? 'grayscale(1)' : 'none',
          opacity: bloqueada ? 0.4 : 1,
        }}>
          <div style={{ width: '55%', height: '55%' }}>{insigniaDef.icono(iconColor)}</div>
        </div>
        {/* Badge nivel */}
        {nivel && (
          <div style={{ position: 'absolute', bottom: -2, right: -2, background: nivel.gradient, borderRadius: '8px', padding: '1px 5px', fontSize: '8px', fontWeight: 'bold', color: nivel.text, border: `1px solid ${nivel.glow}`, boxShadow: `0 0 6px ${nivel.glow}88` }}>
            {nivel.label.slice(0, 2).toUpperCase()}
          </div>
        )}
      </div>
    );
  }

  return (
    <div style={{ width: '100%', background: '#0d0d0d', borderRadius: '16px', overflow: 'hidden', border: nivel ? `1px solid ${nivel.glow}33` : '1px solid #1e1e1e', transition: '0.2s', position: 'relative' }}
      onMouseEnter={e => { if (nivel) e.currentTarget.style.boxShadow = `0 0 20px ${nivel.glow}44`; }}
      onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}>

      {/* Header con gradiente */}
      <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', background: nivel ? nivel.gradient : 'linear-gradient(135deg, #1a1a1a, #111)', position: 'relative', overflow: 'hidden' }}>
        {/* Brillo diagonal */}
        {nivel && <div style={{ position: 'absolute', top: '-50%', left: '-20%', width: '60%', height: '200%', background: nivel.shine, transform: 'rotate(20deg)', pointerEvents: 'none' }} />}

        {/* Icono circular */}
        <div style={{ width: size, height: size, borderRadius: '50%', background: 'rgba(0,0,0,0.2)', backdropFilter: 'blur(4px)', border: `2px solid ${nivel ? nivel.shine : '#333'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: nivel ? `0 4px 20px rgba(0,0,0,0.4), inset 0 1px 0 ${nivel.shine}` : 'none', position: 'relative', zIndex: 1, filter: bloqueada ? 'grayscale(1)' : 'none', opacity: bloqueada ? 0.5 : 1 }}>
          <div style={{ width: '55%', height: '55%' }}>{insigniaDef.icono(iconColor)}</div>
        </div>

        {/* Badge nivel sobre el icono */}
        {nivel && (
          <div style={{ marginTop: '10px', background: 'rgba(0,0,0,0.35)', borderRadius: '12px', padding: '3px 10px', fontSize: '11px', fontWeight: 'bold', color: 'white', letterSpacing: '1.5px', textTransform: 'uppercase', position: 'relative', zIndex: 1, backdropFilter: 'blur(4px)' }}>
            ✦ {nivel.label} ✦
          </div>
        )}
        {bloqueada && (
          <div style={{ marginTop: '10px', color: '#444', fontSize: '11px', letterSpacing: '1px', textTransform: 'uppercase', position: 'relative', zIndex: 1 }}>Bloqueada</div>
        )}
      </div>

      {/* Info */}
      <div style={{ padding: '14px 16px' }}>
        <p style={{ margin: '0 0 3px', fontWeight: 'bold', fontSize: '14px', color: nivel ? 'white' : '#444' }}>
          {nivel ? insigniaDef.nombre[nivelActual] : `${insigniaDef.categoria}`}
        </p>
        <p style={{ margin: '0 0 10px', fontSize: '12px', color: '#555', lineHeight: '1.4' }}>
          {nivel ? insigniaDef.descripcion[nivelActual] : insigniaDef.descripcion.bronce}
        </p>

        {/* Barra de progreso */}
        {!insigniaDef.unico && (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
              <span style={{ fontSize: '11px', color: '#444' }}>
                {bloqueada
                  ? `${valor} / ${insigniaDef.umbrales.bronce}`
                  : siguienteNivel
                    ? `${valor} / ${siguienteUmbral} → ${NIVELES[siguienteNivel].label}`
                    : `Máximo nivel alcanzado`}
              </span>
              {!bloqueada && siguienteNivel && <span style={{ fontSize: '11px', color: nivel?.glow || '#444' }}>{Math.round(progreso)}%</span>}
            </div>
            {(bloqueada || siguienteNivel) && (
              <div style={{ height: '4px', background: '#1a1a1a', borderRadius: '4px', overflow: 'hidden' }}>
                <div style={{ height: '100%', width: `${progreso}%`, background: nivel ? `linear-gradient(90deg, ${nivel.glow}88, ${nivel.glow})` : '#333', borderRadius: '4px', transition: '0.6s ease', boxShadow: nivel ? `0 0 6px ${nivel.glow}` : 'none' }} />
              </div>
            )}
            {!bloqueada && !siguienteNivel && (
              <div style={{ height: '4px', background: nivel?.gradient, borderRadius: '4px', boxShadow: `0 0 8px ${nivel?.glow}` }} />
            )}
          </div>
        )}
      </div>
    </div>
  );
}

// ── Sección de insignias en el perfil ─────────────────────────────────────────
export function SeccionInsignias({ userId, stats, pequeña = false }) {
  if (!stats) return null;

  const insigniasDesbloqueadas = INSIGNIAS_DEF.filter(ins => {
    const valor = stats[ins.campo] || 0;
    return valor >= ins.umbrales.bronce;
  });

  const insigniasBloqueadas = INSIGNIAS_DEF.filter(ins => {
    const valor = stats[ins.campo] || 0;
    return valor < ins.umbrales.bronce;
  });

  if (pequeña) {
    return (
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
        {insigniasDesbloqueadas.map(ins => (
          <InsigniaCard key={ins.id} insigniaDef={ins} valor={stats[ins.campo] || 0} pequeña />
        ))}
        {insigniasDesbloqueadas.length === 0 && (
          <p style={{ fontSize: '13px', color: '#333' }}>Aún sin insignias. ¡Empieza a leer!</p>
        )}
      </div>
    );
  }

  return (
    <div>
      {insigniasDesbloqueadas.length > 0 && (
        <>
          <h3 style={{ fontSize: '12px', color: '#555', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 16px' }}>Desbloqueadas ({insigniasDesbloqueadas.length})</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: '12px', marginBottom: '32px' }}>
            {insigniasDesbloqueadas.map(ins => (
              <InsigniaCard key={ins.id} insigniaDef={ins} valor={stats[ins.campo] || 0} />
            ))}
          </div>
        </>
      )}
      <h3 style={{ fontSize: '12px', color: '#333', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 16px' }}>En progreso</h3>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: '12px' }}>
        {insigniasBloqueadas.map(ins => (
          <InsigniaCard key={ins.id} insigniaDef={ins} valor={stats[ins.campo] || 0} />
        ))}
      </div>
    </div>
  );
}

// ── Calcular y guardar stats del usuario en Firestore ─────────────────────────
export async function calcularStatsUsuario(userId) {
  try {
    const [
      leidos, guardados, valoraciones, seguidoresSnap, eventosSnap, userDoc
    ] = await Promise.all([
      getDocs(query(collection(db, "estados_lectura"), where("userId", "==", userId), where("estado", "==", "leido"))),
      getDocs(query(collection(db, "estados_lectura"), where("userId", "==", userId))),
      getDocs(query(collection(db, "valoraciones"), where("userId", "==", userId))),
      getDocs(query(collection(db, "relaciones"), where("seguidoId", "==", userId))),
      getDocs(query(collection(db, "eventos"), where("activo", "==", true), limit(500))),
      getDoc(doc(db, "users", userId)),
    ]);

    const libros_leidos = leidos.size;
    const libros_guardados = guardados.size;
    const valoracionesCount = valoraciones.size;
    const seguidores = seguidoresSnap.size;
    const mensajes_enviados = userDoc.exists() ? (userDoc.data().mensajes_enviados || 0) : 0;
    const eventos_participados = eventosSnap.docs.filter(d => (d.data().apuntados || []).includes(userId)).length;
    const es_pionero = userDoc.exists() ? (userDoc.data().es_pionero || 0) : 0;
    // invitaciones se incrementa directamente en user_stats, solo leerlo
    const statsDoc = await getDoc(doc(db, "user_stats", userId));
    const invitaciones = statsDoc.exists() ? (statsDoc.data().invitaciones || 0) : 0;
    const invitacionesActivadas = statsDoc.exists() ? (statsDoc.data().invitacionesActivadas || 0) : 0;

    const stats = {
      libros_leidos,
      libros_guardados,
      valoraciones: valoracionesCount,
      seguidores,
      mensajes_enviados,
      eventos_participados,
      es_pionero,
      invitaciones,
      invitacionesActivadas,
    };

    // Solo escribir en Firestore si los valores cambiaron
    const datos = statsDoc.exists() ? statsDoc.data() : {};
    const cambio = Object.keys(stats).some(k => datos[k] !== stats[k]);
    if (cambio) {
      await setDoc(doc(db, "user_stats", userId), { ...stats, actualizadoEn: serverTimestamp() }, { merge: true });
    }
    return stats;
  } catch (e) {
    console.error("Error calculando stats:", e);
    return null;
  }
}

// ── Hook para cargar stats en tiempo real ─────────────────────────────────────
export function useStats(userId) {
  const [stats, setStats] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    if (!userId) return;

    // Calcular stats iniciales
    calcularStatsUsuario(userId).then(s => {
      setStats(s);
      setCargando(false);
    });

    // Debounce para evitar múltiples recálculos en cascada (ahorra reads de Firestore)
    let debounceTimer = null;
    const recalcular = () => {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        calcularStatsUsuario(userId).then(s => { if (s) setStats(s); });
      }, 2000);
    };

    const unsubEstados = onSnapshot(
      query(collection(db, "estados_lectura"), where("userId", "==", userId)),
      () => recalcular()
    );

    const unsubValoraciones = onSnapshot(
      query(collection(db, "valoraciones"), where("userId", "==", userId)),
      () => recalcular()
    );

    const unsubRelaciones = onSnapshot(
      query(collection(db, "relaciones"), where("seguidoId", "==", userId)),
      () => recalcular()
    );

    return () => {
      if (debounceTimer) clearTimeout(debounceTimer);
      unsubEstados(); unsubValoraciones(); unsubRelaciones();
    };
  }, [userId]);

  return { stats, cargando };
}
